import { ConfigService } from "../configService";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";

@Injectable()
export class TaxService {
    public canadianHsCodesAlAndSteel10: any = {};
    public canadianHsCodesAlAndSteel25: any = {};
    public canadianHsCodesChina0: any = {};
    public usaHsCodesChina25: any = {};

    public static Instance: any;

    constructor(public  http: Http) {
        TaxService.Instance = this;
        this.getCanadianCountermeasures10();
        this.getUSAChinaCodes();
    }

    public getCanadianCountermeasures10(): Promise<Array<String>> {
        let url = 'configuration/Canadian_Countermeasures_10.json';

        return this.http.get(url).toPromise().then((x: any) => {
            const res = x.json();

            if (res["10"])
                this.canadianHsCodesAlAndSteel10 = res["10"];

            if (res["25"])
                this.canadianHsCodesAlAndSteel25 = res["25"];

            if (res["0"])
                this.canadianHsCodesChina0 = res["0"];

            return res;
        });
    }

    public getUSAChinaCodes(): Promise<Array<String>> {
        let url = 'configuration/USA_China_Codes.json';

        return this.http.get(url).toPromise().then((x: any) => {
            const res = x.json();
            this.usaHsCodesChina25 = res;
            return res;
        });
    }
}



// WEBPACK FOOTER //
// ./app/services/calculator/tax.service.ts